module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_sattel-984ef623c522d1bf3f6431d29f96665e.png";